/**
 * @generated SignedSource<<b5895038471b549ca4b5010daea895e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapSourceScrapsTaskRestoreInput = {
  scrapSource: string;
  scraps: ReadonlyArray<string>;
};
export type ScrapSourceId_scrapSourceScrapsTaskRestoreMutation$variables = {
  input: ScrapSourceScrapsTaskRestoreInput;
};
export type ScrapSourceId_scrapSourceScrapsTaskRestoreMutation$data = {
  readonly scrapSourceScrapsTaskRestore: {
    readonly id: string;
  };
};
export type ScrapSourceId_scrapSourceScrapsTaskRestoreMutation = {
  response: ScrapSourceId_scrapSourceScrapsTaskRestoreMutation$data;
  variables: ScrapSourceId_scrapSourceScrapsTaskRestoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ScrapSource",
    "kind": "LinkedField",
    "name": "scrapSourceScrapsTaskRestore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapSourceId_scrapSourceScrapsTaskRestoreMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapSourceId_scrapSourceScrapsTaskRestoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8260e0d89669bef5193daa25feda114d",
    "id": null,
    "metadata": {},
    "name": "ScrapSourceId_scrapSourceScrapsTaskRestoreMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapSourceId_scrapSourceScrapsTaskRestoreMutation(\n  $input: ScrapSourceScrapsTaskRestoreInput!\n) {\n  scrapSourceScrapsTaskRestore(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "960c6a51cd92bc6dcc36b7568fe0e438";

export default node;
